import { CdkStepperModule } from "@angular/cdk/stepper";
import { CommonModule } from "@angular/common";
import { ComponentFactoryResolver, NgModule } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from "@angular/material/legacy-progress-spinner";
import { MatStepperModule } from "@angular/material/stepper";
import { LazyLoaderModule } from "@obg/common.lazy-loader";
import { ComponentFactoryService } from "@obg/ngx.ui.core";

import { AnimateDialogHeightResizeModule } from "../../animate-dialog-height-resize/animate-dialog-height-resize.module";

import { FlowStepRendererComponent } from "./flow-step-renderer/flow-step-renderer.component";
import { SequentialFlowStepperComponent } from "./sequential-flow-stepper/sequential-flow-stepper.component";

const DIRECTIVES = [SequentialFlowStepperComponent, FlowStepRendererComponent];

@NgModule({
	imports: [
		CommonModule,
		CdkStepperModule,
		MatStepperModule,
		MatIconModule,
		MatProgressSpinnerModule,
		AnimateDialogHeightResizeModule,
		LazyLoaderModule,
	],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class FlowModule {
	constructor(componentFactoryService: ComponentFactoryService, resolver: ComponentFactoryResolver) {
		componentFactoryService.registerLazyLoadedResolver(resolver, ...DIRECTIVES);
	}
}
